import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@peer-start/ui/reducate";
import { profilePhotos } from "../../../app/profile-photos.js";

const nameParticles = new Set(["van", "de", "der", "den", "het", "ten", "ter", "te"]);

function initials(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? "";
  const surname = parts.slice(1).find((part) => !nameParticles.has(part.toLowerCase()));
  const second = surname?.[0] ?? parts[0]?.[1] ?? "";
  return `${first}${second}`.toUpperCase();
}

export function SituationChangedBy({ id, name }: { id: string; name: string }) {
  const photo = profilePhotos[id];
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            aria-label={name}
            className="rounded-full"
            onClick={(event) => event.stopPropagation()}
            type="button"
          >
            <Avatar aria-hidden="true" size="sm">
              {photo ? <AvatarImage alt="" src={photo} /> : null}
              <AvatarFallback>{initials(name)}</AvatarFallback>
            </Avatar>
          </button>
        </TooltipTrigger>
        <TooltipContent>{name}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
